
import { on, off } from 'element-ui/src/utils/dom';
function selectContent(el){
    const _target = el.target;
    _target.select();
}
const select = {
    inserted:function (el, binding, vNode) {
        const { value } = binding;
        const _event = value || 'focus';
        let _el = el.querySelector("input,textarea")||el;
        _el.addEventListener(_event,selectContent);
    },
    unbind:function (el, binding, vNode) {
        const { value } = binding;
        const _event = value || 'focus';
        let _el = el.querySelector("input,textarea")||el;
        _el.removeEventListener(_event,selectContent);
    }
}
export default select;


// WEBPACK FOOTER //
// ./src/components/cloud-clinic/directives/select/index.js